import CrearPersonaDesdeDeudaPage from "./ReprocesarImputacionCobranzasPage";

export {CrearPersonaDesdeDeudaPage}
export default CrearPersonaDesdeDeudaPage
